export default {
  title: "Начисление баллов",
  toSetDiffPercent:
    "Чтобы устанавливать разный % вознаграждения в зависимости от суммы покупок клиентов, необходимо приобрести тариф «Промо» или «Про+»",
  areUSureToDeleteGroup: "Вы уверены что хотите удалить группу?",
  userGetAwardDuring30Min:
    "Ваш пользователь получит вознаграждение в течении 30 минут с момента проведения операции",
  creatingNewAndEditingNotAvailable:
    "Создание новых и редактирование существующих групп недоступно",
  payAttention: "Обратите внимание!",
  bannerText:
    "Функционал работает только для оцифрованных вами клиентов. <br /><br /> Ваши <b>оцифрованные</b> клиенты получают 50%&nbsp;от&nbsp;указанного в&nbsp;группе процента начисления (комиссия не взымается). Сумма покупок учитывается, не&nbsp;включая сумму скидки.",
  seeRewardScenarios: "См. сценарии распределения вознаграждения",
  createNewGroup: "Создать новую группу",

  tableHeaders: {
    groupNaming: "Наименование<br/>группы",
    pointNaming: "Название торговой<br/>точки",
    purchaseSum: "Сумма<br/>покупки",
    accrualPercent: "Процент<br/>начисления",
    status: "Статус",
  },
};
